export { default } from './JobTally'
